module.exports = "## Time Picker\n\nA [time picker](https://www.google.com/design/spec/components/pickers.html#pickers-time-pickers)\nis used to input a time by displaying an interface the user can interact with.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/TimePicker/README.md
 ** module id = 1087
 ** module chunks = 0
 **/